"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var appender_base_1 = require("./appender.base");
var enums_1 = require("../enums");
/**
 * Writes structured {@link ILogMessage} to the console as `console.log(json)`.
 */
var ConsoleAppender = /** @class */ (function (_super) {
    __extends(ConsoleAppender, _super);
    function ConsoleAppender() {
        var _this = _super.call(this) || this;
        _this.type = enums_1.AppenderType.Console;
        return _this;
    }
    ConsoleAppender.prototype.getAppenderName = function () { return 'ConsoleAppender'; };
    ConsoleAppender.prototype.action = function (message) {
        console.log(message);
    };
    return ConsoleAppender;
}(appender_base_1.Appender));
exports.ConsoleAppender = ConsoleAppender;
//# sourceMappingURL=appender.console.js.map